//import hook react
// import { Buffer } from 'node:buffer';
import CryptoJS from "crypto-js";
import React, { useState, useEffect, useRef } from 'react';
import Alert from 'react-bootstrap/Alert'

//import axios
import axios from 'axios';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import Swal from 'sweetalert2'

const DashboardApp = (p) => {
    // define state alert
    const [alertShow, setAlertShow] = useState(false);
    const [alertVariant, setAlertVariant] = useState("");
    const [alertText, setAlertText] = useState("");

    //define state validation
    const [validation, setValidation] = useState([]);
    const [selectedFile, setSelectedFile] = useState();

    //define state
    const [appList, setAppList] = useState([]);
    const [createModalShow, setCreateModalShow] = useState(false);
    const [createName, setCreateName] = useState("");
    const [createDescription, setCreateDescription] = useState("");
    const [createUrl, setCreateUrl] = useState("");
    const [createFilePath, setCreateFilePath] = useState(selectedFile);
    const [createIsDosen, setCreateIsDosen] = useState(false);
    const [createIsMahasiswa, setCreateIsMahasiswa] = useState(false);
    const [createIsTendik, setCreateIsTendik] = useState(false);
    const [createIsUnitKerja, setCreateIsUnitKerja] = useState(false);

    const [editModalShow, setEditModalShow] = useState(false);
    const [editId, setEditId] = useState(0);
    const [editName, setEditName] = useState("");
    const [editDescription, setEditDescription] = useState("");
    const [editUrl, setEditUrl] = useState("");
    const [editFilePath, setEditFilePath] = useState("");
    const [editIsDosen, setEditIsDosen] = useState(false);
    const [editIsMahasiswa, setEditIsMahasiswa] = useState(false);
    const [editIsTendik, setEditIsTendik] = useState(false);
    const [editIsUnitKerja, setEditIsUnitKerja] = useState(false);

    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [deleteName, setDeleteName] = useState(0);

    //token
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

    //hook useEffect
    useEffect(() => {
        fetchData();

        //set default value
        setCreateName('');
        setCreateDescription('');
        setCreateUrl('');
        setCreateFilePath('');
        setCreateIsDosen(false);
        setCreateIsMahasiswa(false);
        setCreateIsTendik(false);
        setCreateIsUnitKerja(false);
    }, []);

    const fetchData = async () => {
        //fetch user from Rest API
        await axios.get(process.env.REACT_APP_API_URL + '/api/dashboardapp')
            .then((response) => {
                setAppList(response.data.dashboard_app);
            })

        const urlParams = new URLSearchParams(window.location.search);
        let errorCode = urlParams.get('errorcode');

        if (errorCode == 404) {
            Swal.fire({
                title: 'Error',
                text: "User tidak ditemukan atau tidak terdaftar",
                icon: 'error',
                confirmButtonText: 'Ok'
            }).then(
                function () {
                    var url = document.location.href;
                    window.history.pushState({}, "", url.split("?")[0]);
                }
            );
        }
    }

    const createFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    }

    const createHandler = async (e) => {
        e.preventDefault();
        Swal.showLoading();
        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('name', createName);
        formData.append('description', createDescription);
        formData.append('url', createUrl);
        formData.append('file_path', selectedFile);
        formData.append('is_dosen', createIsDosen);
        formData.append('is_mahasiswa', createIsMahasiswa);
        formData.append('is_tendik', createIsTendik);
        formData.append('is_unit_kerja', createIsUnitKerja);

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/dashboardapp/create', formData)
            .then((response) => {
                setAppList(response.data.dashboard_app);
                setCreateModalShow(false);

                // setAlertShow(true);
                // setAlertVariant("secondary");
                // setAlertText("Berhasil menambahkan " + response.data.dashboard_app[0].name + "!");

                Swal.hideLoading();
                Swal.fire({
                    title: 'Sukses',
                    text: "Berhasil menambahkan " + response.data.dashboard_app[0].name + "!",
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });
            })
            .catch((error) => {
                //assign error to state "validation"
                setValidation(error.response.data);
                console.log(error.response.data);
            })
    }

    const createModal = () => {
        setCreateModalShow(true);
        setValidation([]);

        //set default value
        setCreateName('');
        setCreateDescription('');
        setCreateUrl('');
        setCreateFilePath(selectedFile);
        setCreateIsDosen(false);
        setCreateIsMahasiswa(false);
        setCreateIsTendik(false);
        setCreateIsUnitKerja(false);

        setAlertShow(false);
    }

    const editModal = (app) => {
        setEditModalShow(true);

        setEditId(app.id);
        setEditName(app.name);
        setEditDescription(app.description);
        setEditUrl(app.url);
        setEditFilePath(selectedFile);
        setEditIsDosen(app.is_dosen);
        setEditIsMahasiswa(app.is_mahasiswa);
        setEditIsTendik(app.is_tendik);
        setEditIsUnitKerja(app.is_unit_kerja);

        setAlertShow(false);
    };

    const editHandler = async (e) => {
        e.preventDefault();

        Swal.showLoading();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('id', editId);
        formData.append('name', editName);
        formData.append('description', editDescription);
        formData.append('url', editUrl);
        formData.append('file_path', selectedFile);
        formData.append('is_dosen', editIsDosen);
        formData.append('is_mahasiswa', editIsMahasiswa);
        formData.append('is_tendik', editIsTendik);
        formData.append('is_unit_kerja', editIsUnitKerja);

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/dashboardapp/update', formData)
            .then((response) => {
                setAppList(response.data.dashboard_app);
                setEditModalShow(false);

                // setAlertShow(true);
                // setAlertVariant("secondary");
                // setAlertText("Berhasil mengedit " + response.data.dashboard_app[0].name + "!");

                Swal.hideLoading();
                Swal.fire({
                    title: 'Sukses',
                    text: "Berhasil mengedit " + response.data.dashboard_app[0].name + "!",
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });
            })
            .catch((error) => {
                //assign error to state "validation"

                setValidation(error.response.data);
                console.log(error.response.data);
            })
    }

    const deleteModal = (app) => {
        setDeleteModalShow(true);
        setDeleteId(app.id);
        setDeleteName(app.name);

        setAlertShow(false);
    };

    const deleteHandler = async (e) => {
        e.preventDefault();
        Swal.showLoading();

        //send data to server
        await axios.delete(process.env.REACT_APP_API_URL + '/api/dashboardapp/delete/' + deleteId)
            .then((response) => {
                setAppList(response.data.dashboard_app);
                setDeleteModalShow(false);

                // setAlertShow(true);
                // setAlertVariant("secondary");
                // setAlertText("Hapus berhasil!");

                Swal.hideLoading();
                Swal.fire({
                    title: 'Sukses',
                    text: "Berhasil menghapus!",
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });
            })
            .catch((error) => {
                //assign error to state "validation"
                setValidation(error.response.data);
                console.log(error.response.data);
            })
    }

    const ActionHandler = (app) => {

        if (app.url.includes('sudion')) {
            //aplikasi SUDION
            //window.location.replace(app.url + '/sso/login');
	    window.open(`${app.url}/sso/login`);
        } else if (app.url.includes('simakin')) {
            //aplikasi SIMAKIN
            //window.location.replace(app.url + '/sso');
	    window.open(`${app.url}/sso`);
        } else if (app.url.includes('moodle') || app.url.includes('lmsppg')) {
            //aplikasi OLU
            //window.location.replace(app.url + '/login/');
            window.open(`${app.url}/login/`);
        } else if (app.url.includes('amanah')) {
            //aplikasi Amanah
	    //window.location.replace(app.url);
            window.open(app.url);
        } else if (app.url.includes('simakip')) {
            //aplikasi SIMAKIP
            //window.location.replace(app.url + '/login/validate' + '?token=' + token + '&kodedosen=' + p.user.email);
	    var key = "bpticanggih"; //length=22
            var iv  = "abcdef9876543210abcdef9876543210"; //length=22
            const kodedosen = CryptoJS.AES.encrypt(p.user.email, key, { iv: iv }).toString();
	    //const kodedosen = Buffer.from(p.user.email).toString('base64');
	    window.open(`${app.url}/login/validate?token=${token}&kodedosen=${kodedosen}`);
        } else if (app.url.includes('wisuda')) {
            //aplikasi Wisuda
            //window.location.replace(app.url + '?token=' + token + '&kodedosen=' + p.user.nomor_induk + '&usertype=' + p.user.user_type);
	    window.open(`${app.url}?token=${token}&kodedosen=${p.user.nomor_induk}&usertype=${p.user.user_type}`);
        } else if (app.url.includes('kpi')) {
            //aplikasi KPI
            //window.location.replace(app.url + '?token=' + token + '&user_code=' + p.user.email);
	    window.open(`${app.url}?token=${token}&user_code=${p.user.email}`);
        } else {
            //aplikasi SIAP, SIBIMA dan Akademik
            var subToken = token.substring(0, 100);
            //window.location.replace(app.url + '?token=' + subToken + '&kodedosen=' + p.user.nomor_induk + '&usertype=' + p.user.user_type);
	    window.open(`${app.url}?token=${subToken}&kodedosen=${p.user.nomor_induk}&usertype=${p.user.user_type}`);
        }

    };

    return <div>

        <Alert show={alertShow} variant={alertVariant}>
            <Alert.Heading>
                {alertText}
            </Alert.Heading>
        </Alert>

        {((p.user.user_type == 'ADMIN') || (p.user.user_type == 'SUPERADMIN')) ?
            (
                <button
                    className="btn btn-md btn-outline-primary"
                    style={{ marginBottom: '20px' }}
                    onClick={createModal}>Tambah Baru</button>
            ) : ''
        }

        <div className="row g-0">
            {
                appList.map((app, i) =>
                    <div className="col-md-4 border-right py-3" key={i}>
                        <div className="cards">
                            {((p.user.user_type == 'ADMIN') || (p.user.user_type == 'SUPERADMIN')) ?
                                (
                                    <div className="text-right" style={{ marginTop: "10px", marginRight: "10px" }}>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => editModal(app)}>
                                            <span className="fas fa-edit"></span> Edit
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => deleteModal(app)}>
                                            <span className="fas fa-trash"></span> Hapus
                                        </button>
                                    </div>
                                ) : ''
                            }
                            <div className="first bg-white p-4 text-center">
                                <img src={app.file_path} width="100" />
                                <h5>{app.name}</h5>
                                <p className="card-line">{app.description}</p>
                                <button onClick={() => ActionHandler(app)} className="btn btn-buka">
                                    <i className="fas fa-link pr-2" aria-hidden="true"></i>Buka
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >

        <Modal show={createModalShow} onHide={() => { setCreateModalShow(false) }}>
            <Modal.Header closeButton>
                <Modal.Title>Tambah Baru</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            onChange={(e) => setCreateName(e.target.value)}
                            value={createName}
                            autoFocus
                            isInvalid={!!validation.name}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            {validation.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Deskripsi</Form.Label>
                        <Form.Control
                            onChange={(e) => setCreateDescription(e.target.value)}
                            value={createDescription}
                            as="textarea"
                            rows={3}
                        ></Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>URL</Form.Label>
                        <Form.Control
                            onChange={(e) => setCreateUrl(e.target.value)}
                            value={createUrl}
                            isInvalid={!!validation.url}
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                            {validation.url}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Logo</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            onChange={createFileChange}
                        ></Form.Control>
                    </Form.Group>

                    <div className="row">
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    label="DOSEN"
                                    onChange={(e) => setCreateIsDosen(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    label="MAHASISWA"
                                    onChange={(e) => setCreateIsMahasiswa(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    label="TENDIK"
                                    onChange={(e) => setCreateIsTendik(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    label="UNIT KERJA"
                                    onChange={(e) => setCreateIsUnitKerja(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                        </div>
                    </div>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setCreateModalShow(false) }}>
                    Tutup
                </Button>
                <Button variant="primary" onClick={createHandler}>
                    Simpan
                </Button>
            </Modal.Footer>
        </Modal>

        <Modal show={editModalShow} onHide={() => { setEditModalShow(false) }}>
            <Modal.Header closeButton>
                <Modal.Title>Edit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            onChange={(e) => setEditName(e.target.value)}
                            value={editName}
                            autoFocus
                        ></Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Deskripsi</Form.Label>
                        <Form.Control
                            onChange={(e) => setEditDescription(e.target.value)}
                            value={editDescription}
                            as="textarea"
                            rows={3}
                        ></Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>URL</Form.Label>
                        <Form.Control
                            onChange={(e) => setEditUrl(e.target.value)}
                            value={editUrl}
                        ></Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Logo</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            onChange={createFileChange}
                        ></Form.Control>
                    </Form.Group>

                    <div className='row'>
                        <div className='col-md-6'>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    id="chkEditDosen"
                                    label="DOSEN"
                                    checked={editIsDosen == "1" ? true : false}
                                    onChange={(e) => setEditIsDosen(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    id="chkEditMhs"
                                    label="MAHASISWA"
                                    checked={editIsMahasiswa == "1" ? true : false}
                                    onChange={(e) => setEditIsMahasiswa(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                        </div>
                        <div className='col-md-6'>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    id="chkEditTendik"
                                    label="TENDIK"
                                    checked={editIsTendik == "1" ? true : false}
                                    onChange={(e) => setEditIsTendik(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    id="chkEditUnitk"
                                    label="UNIT KERJA"
                                    checked={editIsUnitKerja == "1" ? true : false}
                                    onChange={(e) => setEditIsUnitKerja(e.target.checked)}
                                ></Form.Check>
                            </Form.Group>
                        </div>
                    </div>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setEditModalShow(false) }}>
                    Tutup
                </Button>
                <Button variant="primary" onClick={editHandler}>
                    Simpan
                </Button>
            </Modal.Footer>
        </Modal>

        <Modal show={deleteModalShow} onHide={() => { setDeleteModalShow(false) }}>
            <Modal.Header closeButton>
                <Modal.Title>Hapus</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Apakah Anda yakin untuk menghapus <b>{deleteName}</b> ?</span>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setDeleteModalShow(false) }}>
                    Tidak
                </Button>
                <Button variant="primary" onClick={deleteHandler}>
                    Ya
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
}

export default DashboardApp;
